import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ColumnChartComponent} from "@/features/dashboard/components/collumn-chart/collumn-chart.component";
import {ChartConfiguration, ChartOptions} from "chart.js";
import {ApiService} from "@/modules//dashboard/infra/api.service";
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import {DashboardData, DashboardResponse} from "@/modules//dashboard/core/types";

@Component({
  selector: 'app-column-items',
  standalone: true,
  imports: [
    ColumnChartComponent,
    NzButtonModule,
    NzIconModule,
    NzToolTipModule
  ],
  templateUrl: './column-items.component.html',
  styleUrl: './column-items.component.scss'
})
export class ColumnItemsComponent implements OnInit {

  @ViewChild(ColumnChartComponent) columnChart?: ColumnChartComponent;
  public chartOptions!: ChartOptions
  public chartData!: ChartConfiguration['data']
  public loading: boolean = false

  private apiData: DashboardData[] = []

  @Input() limit: number = 6;
  @Input() expanded: boolean = false;
  @Input() isMonitorMode: boolean = false;

  constructor(private dashboardService: ApiService) {}

  ngOnInit() {
    this.getApiChartData();
  }


  getApiChartData() {
    this.loading = true
    this.dashboardService.findAll().subscribe({
      next: (data: DashboardResponse<DashboardData>) => {

        this.apiData = data.items
        this.setChartData(this.apiData)
        this.setChartOptions();
        this.loading = false
      },
      error: (err: Error) => {
        err.message
        this.loading = false
      }
    })
  }

  setChartOptions(): void {
    this.chartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        x: {title: {display: true, text: 'Mês'}},
        y: {title: {display: true, text: 'Modelo'}}
      },
      plugins: {
        legend: {position: 'bottom'}
      }
    }
  } 

  setChartData(dashBoardData: DashboardData[]) {
    const modelCounts = dashBoardData.reduce((acc, item) => {
      if (item.brand_name !== 'Veiculos') {
        acc[item.product_name] = (acc[item.product_name] || 0) + 1;
      }
      return acc;
    }, {} as Record<string, number>);

    const topModels = Object.entries(modelCounts)
      .sort(([, countA], [, countB]) => countB - countA)
      .slice(0, this.limit);

    const labels = topModels.map(([productName]) => productName);
    const data = topModels.map(([, count]) => count);

    this.chartData = {
      labels: labels,
      datasets: [
        {
          data: data,
          label: 'Check-lists',
          backgroundColor: '#ff5151cc',
          borderColor: '#ff5151cc',
          borderWidth: 1,
          borderRadius: 10
        }
      ]
    };
  }

  public resizeChart(): void {
    this.columnChart?.resizeChart();
  }

  public exportChart(): void {
    if (this.columnChart && this.columnChart.chartDirective && this.columnChart.chartDirective.chart) {
      const url = this.columnChart.chartDirective.chart.toBase64Image();
      const link = document.createElement('a');
      link.download = 'Check-lists por Modelo.png';
      link.href = url;
      link.click();
    }
  }
}
